export function normalizeApiData(result, response) {
  return {
    code: result.status,
    status: result.ok,
    data: response,
  };
}
